import { useMemo } from 'react';

import { Stack } from '@lyearn/ui';

import { getIsCorrectAnswerChanged } from '../../../../../../utils/questions';
import CorrectOptionChangedInfo from '../CorrectOptionChangedInfo';
import LimitedEditingInfo from '../LimitiedEditingInfo';
import { EditingInfoProps } from './types';

const EditingInfo: React.FC<EditingInfoProps> = (props) => {
  const { limitedEditingInfoState, questionType, onChange, question, initialQuestion } = props;

  const isCorrectOptionChanged = useMemo(
    () => getIsCorrectAnswerChanged(initialQuestion?.options?.set, question.options?.set),
    [initialQuestion?.options?.set, question.options?.set],
  );

  return (
    <Stack direction="col" gapY={24}>
      <LimitedEditingInfo questionType={questionType} state={limitedEditingInfoState} />
      {isCorrectOptionChanged ? (
        <CorrectOptionChangedInfo
          initialQuestion={initialQuestion}
          question={question}
          onChange={onChange}
        />
      ) : null}
    </Stack>
  );
};

export default EditingInfo;
